import { render, staticRenderFns } from "./kubevirt.io.virtualmachine.vue?vue&type=template&id=decafc62&"
import script from "./kubevirt.io.virtualmachine.vue?vue&type=script&lang=js&"
export * from "./kubevirt.io.virtualmachine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports